import {graphql, useStaticQuery} from 'gatsby'

import type {CopyExperimentsQuery} from '@/graphql-types'
import type {LocaleCode} from '@helios/shared/locale/locales'

import {useLocalizedContent} from './use-localized-content'

export const useCopyExperiments = (locale?: LocaleCode) => {
    const data: CopyExperimentsQuery = useStaticQuery(graphql`
        query CopyExperiments {
            allPrismicCopyExperiment {
                nodes {
                    uid
                    lang
                    data {
                        body {
                            ... on PrismicCopyExperimentDataBodyVariant {
                                primary {
                                    id
                                    text
                                    rich_text {
                                        raw
                                    }
                                    title {
                                        raw
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `)

    const content = useLocalizedContent(data.allPrismicCopyExperiment.nodes, locale)

    return content
}
